import PdfSvgIcon from "./PDF.svg";
function PdfIcon() {
  return <img className="pdf-img" src={PdfSvgIcon} alt="pdf-svg" />;
}

export default PdfIcon;
